module.exports = __webpack_public_path__ + "img/banner-1.d491cbe9.jpg";